import {
  DirectSalesProductTemplateFrameListFilter,
  ProductTemplateRulesResponse,
} from 'components/common/types/DirectSalesProductTemplate.types';
import { DirectSalesFilterScope } from 'components/common/types/DirectSalesCampaign.types';
import { RouteFrameCode } from 'components/common/types/Deal.types';
import { FileList } from 'components/common/types';
import { File } from 'utils/framesUtils.types';
import { SelectionPermission, ProductManagement } from 'store/productManagement/reducer.types';

const transformFrameListValue = (
  frameListRule: ProductTemplateRulesResponse,
): { routeFrameCodes: RouteFrameCode[]; listFiles: FileList[] } | undefined => {
  if (frameListRule.behaviour !== 'FIXED' || !frameListRule.fixedSet) {
    return undefined;
  }

  const fixedSet = frameListRule.fixedSet as DirectSalesProductTemplateFrameListFilter[];
  const routeFrameCodes: RouteFrameCode[] = [];
  const listFilesMap = new Map<string, FileList>();

  fixedSet.forEach((filter) => {
    const include = filter.selectionType === DirectSalesFilterScope.INCLUDE;

    if (filter.filename === null) {
      filter.unitsIds.forEach((unitId) => {
        routeFrameCodes.push({
          code: unitId,
          name: unitId,
          include,
        });
      });
    } else {
      const { filename } = filter;
      if (!listFilesMap.has(filename)) {
        const file = {
          path: filename,
          name: filename,
        } as Partial<File>;

        listFilesMap.set(filename, {
          name: filename,
          file,
          fileContents: [],
        } as unknown as FileList);
      }

      const fileList = listFilesMap.get(filename)!;
      if (!fileList.fileContents) {
        fileList.fileContents = [];
      }

      filter.unitsIds.forEach((unitId) => {
        fileList.fileContents!.push({
          code: unitId,
          name: unitId,
          include,
        });
      });
    }
  });

  return {
    routeFrameCodes,
    listFiles: Array.from(listFilesMap.values()),
  };
};

export const transformFrameListFromResponse = (
  frameListRule: ProductTemplateRulesResponse,
  frameListPermission: SelectionPermission,
): ProductManagement['newProduct']['frameList'] => {
  if (frameListPermission === SelectionPermission.DISABLED) {
    return undefined;
  }

  if (frameListPermission === SelectionPermission.ALL_OPTIONS) {
    return { selectionPermission: frameListPermission };
  }

  const frameListValue = transformFrameListValue(frameListRule);
  return { selectionPermission: frameListPermission, value: frameListValue };
};
